import React, {useEffect, useMemo, useState} from 'react'
import useQueryRecommend from '../../../../hooks/api/recommend/useQueryRecommend'
import RecommendTable from './RecommendTable'
import {IRecommend} from '../../../../apis/recommend/getRecommend'
import RecommendPostContainer from './RecommendPostContainer'
import WizPagination from '../../../../components/pagination/WizPagination'

interface IProps {
    className?: string
}

const RecommendContainer: React.FC<IProps> = ({className}) => {
    const [currentPage, setCurrentPage] = useState(1)
    const {data, refetch} = useQueryRecommend(currentPage)

    const recommendList = useMemo(() => {
        let list: IRecommend[] = []
        data?.data?.map(item => list.push(item))
        return list
    }, [data])

    useEffect(() => {
        refetch()
    }, [data])

    useEffect(() => {
        refetch()
    }, [currentPage])

    // 최신 featured 목록을 다시 받아 0번째 항목의 rank보다 1 높은 값을 반환
    const getNextRank = async () => {
        const {data: latest} = await refetch()
        return (latest?.data?.[0]?.rank ?? 0) + 1
    }


    return (
        <div className={className}>
            <RecommendTable data={recommendList}/>
            <WizPagination
                totalPage={data?.pageInfo?.total_count}
                currentPage={currentPage}
                onPageChange={item => setCurrentPage(item)}
            />

            <RecommendPostContainer className={'mt-[60px]'} getNextRank={getNextRank} onPinned={refetch} />
        </div>
    )
}

export default RecommendContainer
